import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetUserTypes = createAsyncThunk(
  "dropdown/GetUserTypes",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/user/type/list/`)
    return data
  }
);
